/**
 * GMA-1616 (CompassCare Web 1/14 — Foundation) — canonical navigation model.
 *
 * ONE ordered list of the 13 facelift sections. The left icon sidebar renders
 * from it and the router stubs its routes from it, so navigation and routing
 * can never drift. `icon` is a @mui/icons-material export name (resolved by the
 * Sidebar, not imported here, to keep this a pure data module).
 *
 * Routes are namespaced under /web/ so the facelift can be built and QA'd
 * alongside the current app without colliding with existing routes.
 */

export const WEB_NAV_SECTIONS = Object.freeze(
  [
    { key: "overview", label: "Overview", path: "/web/overview", icon: "Dashboard" },
    { key: "vitals", label: "Vitals", path: "/web/vitals", icon: "MonitorHeart" },
    { key: "clients", label: "Clients", path: "/web/clients", icon: "Groups" },
    { key: "alerts", label: "Alerts", path: "/web/alerts", icon: "NotificationsActive" },
    { key: "map", label: "Clients' Map", path: "/web/map", icon: "Map" },
    { key: "dispatch", label: "Dispatch", path: "/web/dispatch", icon: "CallSplit" },
    { key: "devices", label: "Devices", path: "/web/devices", icon: "Sensors" },
    { key: "reports", label: "Reports", path: "/web/reports", icon: "Assessment" },
    { key: "intel", label: "INTEL", path: "/web/intel", icon: "Insights" },
    { key: "messages", label: "Messages", path: "/web/messages", icon: "Forum" },
    { key: "schedule", label: "Schedule", path: "/web/schedule", icon: "CalendarMonth" },
    { key: "audit", label: "Audit Log", path: "/web/audit", icon: "History" },
    { key: "settings", label: "Settings", path: "/web/settings", icon: "Settings" },
  ].map(Object.freeze),
);

export const WEB_NAV_KEYS = Object.freeze(WEB_NAV_SECTIONS.map((s) => s.key));

/**
 * Resolve the nav section that owns a given pathname. Matches an exact section
 * path or any nested route under it (e.g. /web/clients/42 -> Clients), so the
 * sidebar can highlight the active section on detail pages too.
 * @param {string} pathname
 * @returns {object|undefined} the owning section, or undefined if outside /web/
 */
export function findNavSectionByPath(pathname) {
  if (typeof pathname !== "string") return undefined;
  return WEB_NAV_SECTIONS.find(
    (s) => pathname === s.path || pathname.startsWith(`${s.path}/`),
  );
}
